import { useMutation, useQuery } from '@apollo/client'
import React, { useEffect, useState } from 'react'
import {
  CHANGE_STATUS_SURVEY,
  DELETE_SURVEY,
  GET_ALL_SURVEYS,
} from '../../graphql/Catalog/Surveys/surveys'
import ContentHeader from '../Layout/ContentHeader'
import LayoutTable from '../Global/LayoutTable'
import { toastSweetAlert } from '../Helpers/ToastSweetAlert'
import { useLoading } from '../../LoadingOverlay/LoadingOverlayContext'

const Surveys = () => {
  //LOADING
  const { showLoading, hideLoading } = useLoading()

  const [dataTable, setDataTable] = useState([])
  const [totalCount, setTotalCount] = useState(0)
  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
  })

  const {
    data: dataSurveys,
    loading: loadingSurveys,
    error: errorSurveys,
    refetch,
  } = useQuery(GET_ALL_SURVEYS, {
    variables: {
      searchQuery: pagePagination.searchQuery,
      limit: pagePagination.limit,
      offset: pagePagination.offset,
    },
    fetchPolicy: '',
  })

  const [changeStatus] = useMutation(CHANGE_STATUS_SURVEY)

  useEffect(() => {
    try {
      if (loadingSurveys) return
      if (errorSurveys)
        return toastSweetAlert({
          mode: 'error',
          message: errorSurveys.message,
        })

      const surveys = dataSurveys.getAllSurveys.rows.map((item) => {
        return {
          id: item.id,
          titulo: item.title,
          descripcion: item.description,
          '': (
            <button
              className={`btn btn-sm btn-outline-${
                item.status === 3
                  ? 'secondary'
                  : item.status === 2
                  ? 'success'
                  : 'info'
              }`}
              onClick={() => handleStatus(item.id, item.status + 1)}
              disabled={item.status === 3}
            >
              {item.status === 1
                ? 'Publicar'
                : item.status === 2
                ? 'Finalizar'
                : item.status === 3
                ? 'Finalizado'
                : 'Sin estado'}
            </button>
          ),
          estado: (
            <>
              {item.status === 3 ? (
                <span className="badge badge-secondary">Finalizado</span>
              ) : item.status === 2 ? (
                <span className="badge badge-success">Activo</span>
              ) : (
                <span className="badge badge-info">Pendiente</span>
              )}
            </>
          ),
          // inicio: item.start_date,
          // fin: item.end_date,
        }
      })

      setDataTable(surveys)
      setTotalCount(dataSurveys.getAllSurveys.count)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingSurveys, dataSurveys, errorSurveys])

  const handleStatus = async (id, status) => {
    console.log(id, status)
    try {
      const response = await toastSweetAlert({
        mode: 'modalConfirmCancel',
        message: `¿Estas seguro de cambiar el estado de la encuesta?`,
        icon: 'info',
      })

      if (!response.isConfirmed) return
      showLoading()

      const { data } = await changeStatus({
        variables: {
          id,
          status,
        },
      })

      if (data.changeStatusSurvey) {
        toastSweetAlert({
          mode: 'ok',
          message: 'Estado de la encuesta cambiado con éxito',
        })
        await refetch()
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <>
      <ContentHeader title="Encuestas" windowTitle="Encuestas" breadcrumb="" />

      <LayoutTable
        hideId
        title="Lista de Encuestas"
        data={dataTable}
        totalCount={totalCount}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        loadingData={loadingSurveys}
        gql={DELETE_SURVEY}
        requery={GET_ALL_SURVEYS}
        refetchFunctionQueries={refetch}
        exportImportButton={false}
        detailsText="Respuestas"
      />
    </>
  )
}

export default Surveys
